import React from 'react';
import { Container, Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { Breadcrumbs, H5 } from '../../../AbstractElements';
import { box_shadow, Examples, Shadowcode, Shadowpara, Shadowpara1, Shadowpara2, Shadowpara3, shadow_none } from '../../../Constant';
import LargeShadows from './Large';
import NoShadows from './NoShadow';
import RegularShadows from './Regular';
import SmallShadows from './Small';

const ShadowContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Box Shadow' parent='Ui Kits' title='Box Shadow' />
      <Row>
        <Col sm='12'>
          <Card className='box-shadow-title'>
            <CardHeader className='pb-0'>
              <H5>{Examples}</H5>
              <span>
                {Shadowpara} <code>{Shadowcode}</code>, {Shadowpara1} <code>{box_shadow}</code> {Shadowpara2} <code>{shadow_none}</code> {Shadowpara3}
              </span>
            </CardHeader>
            <CardBody className='row'>
              <LargeShadows />
              <RegularShadows />
              <SmallShadows />
              <NoShadows />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ShadowContainer;
